exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".top-content-block {\n  display: flex;\n  flex-direction: column;\n  min-height: 220px;\n}\n.read-more {\n  align-self: flex-end;\n  cursor: pointer;\n  color: #0f7db8;\n  margin: 0;\n}\n", ""]);

// exports
